import PartnersCommunities from 'sly/partners/communities';

export const getServerSideProps = () => ({ props: {} });

export default PartnersCommunities;
